
import ProductDetailHero from './components/ProductDetailHero';
import ProductFeatures from './components/ProductFeatures';
import ProductSpecifications from './components/ProductSpecifications';
import ComplianceSection from './components/ComplianceSection';
import RelatedProducts from './components/RelatedProducts';
import ProductCTA from './components/ProductCTA';

export default function EmergencyExitSignsPage() {
  const product = {
    id: 10,
    title: 'Emergency Exit Signs',
    category: 'Emergency Lighting',
    brand: 'FlameGuardQA',
    model: 'FG-EES-01',
    certification: 'Self-Testing',
    status: 'Available',
    image: 'https://readdy.ai/api/search-image?query=Green%20LED%20emergency%20exit%20sign%20with%20running%20man%20symbol%20and%20directional%20arrow%2C%20professional%20self-testing%20evacuation%20lighting%20with%20battery%20backup%20mounted%20on%20white%20wall%20in%20Qatar%20commercial%20building%20with%20QCDD%20certification&width=600&height=600&seq=emergency-exit-signs-detail&orientation=squarish',
    description: 'LED illuminated exit signs with self-testing feature and battery backup for safe evacuation. These intelligent signs automatically test themselves every 30 days to ensure reliable operation during emergencies.'
  };

  const features = [
    'Self-testing every 30 days',
    'High-brightness LEDs',
    'Directional arrow options',
    'Rechargeable battery backup',
    'Low power consumption',
    'Automatic fault detection',
    'Multiple mounting options',
    'Long-life LED technology'
  ];

  const specifications = [
    { label: 'Model', value: 'FG-EES-01' },
    { label: 'Type', value: 'Self-Testing LED Exit Sign' },
    { label: 'Power Supply', value: '230V AC' },
    { label: 'Battery Type', value: 'Ni-Cd Rechargeable' },
    { label: 'Emergency Duration', value: '3 Hours' },
    { label: 'LED Life', value: '50,000 Hours' },
    { label: 'Self-Test Interval', value: '30 Days' },
    { label: 'Viewing Distance', value: 'Up to 30m' },
    { label: 'Operating Temperature', value: '0°C to 40°C' },
    { label: 'Protection Rating', value: 'IP20' },
    { label: 'Certification', value: 'QCDD, CE' },
    { label: 'Warranty', value: '3 Years' }
  ];

  const relatedProducts = [
    {
      id: 11,
      title: 'Emergency Light Fittings',
      image: 'https://readdy.ai/api/search-image?query=White%20LED%20emergency%20light%20fitting%20with%20twin%20spotlights%20and%20battery%20backup%2C%20professional%20emergency%20lighting%20system%20with%20automatic%20testing%20function%20mounted%20on%20ceiling&width=300&height=200&seq=emergency-lights-related&orientation=landscape',
      category: 'Emergency Lighting',
      compliance: '3-Hour Backup'
    },
    {
      id: 12,
      title: 'Central Battery Systems',
      image: 'https://readdy.ai/api/search-image?query=Professional%20central%20battery%20emergency%20lighting%20system%20with%20control%20panel%20and%20monitoring%20display%2C%20QCDD%20approved%20centralized%20emergency%20power%20system%20with%20automatic%20testing&width=300&height=200&seq=central-battery-related&orientation=landscape',
      category: 'Emergency Lighting',
      compliance: 'Monitored System'
    },
    {
      id: 16,
      title: 'Fire Safety Signage',
      image: 'https://readdy.ai/api/search-image?query=Collection%20of%20fire%20safety%20signs%20including%20exit%20signs%2C%20fire%20extinguisher%20location%20signs%20and%20hazard%20warning%20signs%20with%20photoluminescent%20and%20reflective%20materials&width=300&height=200&seq=safety-signs-related&orientation=landscape',
      category: 'Signage',
      compliance: 'Photoluminescent'
    },
    {
      id: 1,
      title: 'Fire Alarm Control Panel',
      image: 'https://readdy.ai/api/search-image?query=Professional%20intelligent%20fire%20alarm%20control%20panel%20with%20digital%20LCD%20display%20and%20red%20indicator%20lights%2C%20advanced%20addressable%20fire%20detection%20system%20with%20network%20connectivity&width=300&height=200&seq=alarm-control-panel-related5&orientation=landscape',
      category: 'Fire Alarms',
      compliance: 'QCDD Approved'
    }
  ];

  return (
    <div className="min-h-screen">
      <ProductDetailHero product={product} />
      <ProductFeatures features={features} />
      <ProductSpecifications specifications={specifications} />
      <ComplianceSection />
      <RelatedProducts products={relatedProducts} />
      <ProductCTA />
      
      {/* Floating WhatsApp Button */}
      <div className="fixed bottom-8 right-8 z-50">
        <a 
          href="https://wa.me/97455544093"
          target="_blank"
          rel="noopener noreferrer"
          className="w-14 h-14 bg-green-500 hover:bg-green-600 text-white rounded-full shadow-2xl hover:shadow-3xl transition-all duration-300 flex items-center justify-center group"
        >
          <i className="ri-whatsapp-line text-2xl group-hover:scale-110 transition-transform"></i>
        </a>
      </div>
    </div>
  );
}
